import { render, staticRenderFns } from "./PlatFormManageDialog.vue?vue&type=template&id=34da8932&scoped=true"
import script from "./PlatFormManageDialog.vue?vue&type=script&lang=js"
export * from "./PlatFormManageDialog.vue?vue&type=script&lang=js"
import style0 from "./PlatFormManageDialog.vue?vue&type=style&index=0&id=34da8932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34da8932",
  null
  
)

export default component.exports